import request from '../index';

export interface CrashBetRecordsBetItem {
  amount: number;
  cashOutAt: number;
  currency: string;
  gameId: number;
  payoutMultiplier: number;
  roundId: number;
  userId: number;
  userName: string;
  payout?: number;
  usdAmount: string;
  usdPayout: string;
}

export interface BetbyJWTTokenBodyParams {
  amount: number;
  payoutMultiplier: number;
  currency: string;
}

export const crashBet = async (data: BetbyJWTTokenBodyParams) => {
  return await request<CrashBetRecordsBetItem>({
    url: '/api/game/crash/bet',
    method: 'post',
    data,
  });
};

export const crashCancel = async (data: {
  amount: string;
  currency: string;
  payoutMultiplier: string;
}) => {
  return await request({
    url: '/api/game/crash/cancel',
    method: 'POST',
    data,
  });
};

export const crashCashout = async (payoutMultiplier: number) => {
  return await request({
    url: '/api/game/crash/cashout',
    method: 'POST',
    data: { payoutMultiplier },
  });
};

export interface CrashBetRecords {
  bets: CrashBetRecordsBetItem[];
  totalAmount: number;
  totalPlayers: number;
}

export const currentCrashBetRecords = async () => {
  return await request<CrashBetRecords>({
    url: '/api/game/crash/current/bet/records',
    method: 'POST',
  });
};

export interface CrashGameRankItem {
  multiplier: number;
  payout: number;
  userId: number;
  userName: string;
  amount: number;
}

export const crashGameRanks = async (data: {
  gameId: number;
  roundId: number;
}) => {
  return await request<CrashGameRankItem[]>({
    url: '/api/game/crash/game/rank',
    method: 'POST',
    data,
  });
};

export interface CrashLatestGameItem {
  hash: string;
  id: string;
  result: string;
  roundId: string;
  seed: string;
  startTime: string;
}

export interface CrashLatestGame {
  games: CrashLatestGameItem[];
  totalNum: number;
  isEnd: boolean;
}

export const crashLatest = async (data: { page: number; pageSize: number }) => {
  return await request<CrashLatestGame>({
    url: '/api/game/crash/latest/games',
    method: 'POST',
    data,
  });
};

// export const crashSettle = async () => {
//   await request({ url: '/api/game-ws/crash/settle', method: 'POST' });
// };
// export const crashStart = async () => {
//   await request({ url: '/api/game-ws/crash/start', method: 'POST' });
// };

export interface UserGamesItem {
  amount: number;
  currency: string;
  multiplier: number;
  payout: number;
  startTime: string;
  uid: number;
}

export const crashUserGames = async (data: {
  gameId: number;
  page: number;
  pageSize: number;
  uid: number;
}) => {
  return await request<UserGamesItem[]>({
    url: '/api/game/crash/user/games',
    method: 'POST',
    data,
  });
};

export const currentBet = () =>
  request<{ amount: number; payoutMultiplier: number; elapsed: number }>({
    url: '/api/game/crash/user/current/bet',
    method: 'POST',
    data: {},
  });
